import { DisturbanceType, DisturbanceRegion, DisturbanceStatus, DisturbanceArea } from '@config/DisturbanceConfig';

export interface FilterState {
  classification: string;
  customerId: string;
  affectedElements: string[];
  area: string[];
  status: string[];
  startFrom: string;
  startUntil: string;
  region: string[];
}

export interface Filter {
  value: string;
  text: string;
}

export const DisturbanceClassificationFilter: Filter[] = [{ value: 'INTERNAL_ONLY', text: 'filter.classification.internal' }];

export const DisturbanceClientFilter: Filter = { value: 'CLIENT_ONLY', text: 'filter.client.only' };

export const DisturbanceCurrentStatusFilter: Filter = { value: 'CURRENT_STATUS', text: 'filter.status.current' };

export const DisturbanceAreaFilter: Filter[] = [
  { value: 'FIX', text: 'filter.area.fix' },
  { value: 'MOB_VAS', text: 'filter.area.mob.vas' },
  { value: 'MOB_RAN', text: 'filter.area.mob.ran' },
  { value: 'IT', text: 'filter.area.it' },
  { value: 'TV', text: 'filter.area.tv' },
  { value: 'NOT_SET', text: 'filter.area.not.set' }
];

export const DisturbanceStatusFilter: Filter[] = [
  { value: DisturbanceStatus.OPEN, text: 'filter.status.open' },
  { value: DisturbanceStatus.CLOSED, text: 'filter.status.closed' },
  { value: DisturbanceStatus.DEADEND, text: 'filter.status.dead-end' }
];

export const DisturbanceRegionFilter: Filter[] = [
  { value: DisturbanceRegion.HARJUMAA, text: 'filter.county.harjumaa' },
  { value: DisturbanceRegion.HIIUMAA, text: 'filter.county.hiiumaa' },
  { value: DisturbanceRegion.IDA_VIRUMAA, text: 'filter.county.ida.virumaa' },
  { value: DisturbanceRegion.JARVAMAA, text: 'filter.county.jarvamaa' },
  { value: DisturbanceRegion.JOGEVAMAA, text: 'filter.county.jogevamaa' },
  { value: DisturbanceRegion.LAANEMAA, text: 'filter.county.laanemaa' },
  { value: DisturbanceRegion.LAANE_VIRUMAA, text: 'filter.county.laane.virumaa' },
  { value: DisturbanceRegion.PARNUMAA, text: 'filter.county.parnumaa' },
  { value: DisturbanceRegion.POLVAMAA, text: 'filter.county.polvamaa' },
  { value: DisturbanceRegion.RAPLAMAA, text: 'filter.county.raplamaa' },
  { value: DisturbanceRegion.SAAREMAA, text: 'filter.county.saaremaa' },
  { value: DisturbanceRegion.TARTUMAA, text: 'filter.county.tartumaa' },
  { value: DisturbanceRegion.VALGAMAA, text: 'filter.county.valgamaa' },
  { value: DisturbanceRegion.VILJANDIMAA, text: 'filter.county.viljandimaa' },
  { value: DisturbanceRegion.VORUMAA, text: 'filter.county.vorumaa' }
];
